import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxy8g2czm6: FaireProductEntity = {
  token: "p_mxy8g2czm6",
  type: "product",
  name: "Sinus Relief Shower Spray - Eucalyptus, Peppermint, Tea Tree",
  brandToken: "b_35vnge4tj4",
  brandName: "Ani’s Market LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/133666dde08dd3a24a609ec7bf9fd1e42335e26329a07bf091787ffca42a1993.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0861c46591fa25823c0b7d8689fb24d7f2bfb841b7b389fde57ca1ba677662ad.jpeg",
    "https://cdn.faire.com/fastly/e9b2102720ef43552fc867bb5117b47dedaed05042b7c4c4fb5ce30bf89963ea.jpeg",
    "https://cdn.faire.com/fastly/db23b02bfce8317969323b510a4b9e4292b4f3dbf1b865efa0ceddf547f60d3d.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "Unlock your sinuses with this powerful aromatherapy blend of eucalyptus, tea tree, and peppermint essential oils! Just spray in the shower and feel the invigorating scent and relief wash over you. Soothe your senses and invigorate your spirit!\n\nDid you know?\n\n~ Peppermint oil aromatherapy is known for treating colds and coughs, reducing stress and reducing pain.\n~ Tea Tree oil could prevent infection and is commonly used to promote healing as it appears to increase the activity of your white blood cells, which help fight germs.\n~ Eucalyptus essential oil aromatherapy is commonly known to help with coughs, as well as fight pulmonary concerns such as asthma, bronchitis, sinusitis and more.\n\n\nHow to use: shake the bottle and spray into shower water. Enjoy the aromatherapy as the shower steam mixes with our 100% essential oil blend.\n\nIngredients: 100% essential oil blend.\n\nNo dyes or colors.\n\nNET WT: 2oz\n\n\n\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:11.574Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
